const matchFinishesData = [
    {
        'name': 'Interference DQ',
        'description': 'An interference causes a participant to get disqualified.',
        'cost': 0,
        'winMultiplier': 0.1,
        'lossMultiplier': 0.0,
        'ratingEffect': -1,
        'changeChampionship': false,
        'affectRecord': true,
        'affectMorale': false,
        'feudStalenessEffect': 0.5,
        'category': 'dusty',
        'interference': true
    },
    {
        'name': 'DQ',
        'description': 'A participant gets disqualified for using unfair means.',
        'cost': 0,
        'winMultiplier': 0.1,
        'lossMultiplier': 0.0,
        'ratingEffect': -1,
        'changeChampionship': false,
        'affectRecord': true,
        'affectMorale': false,
        'feudStalenessEffect': 0.5,
        'category': 'dusty',
        'interference': false
    },
    {
        'name': 'Cheating',
        'description': 'A participant uses illegal tactics to win.',
        'cost': 0,
        'winMultiplier': 0.5,
        'lossMultiplier': 0.4,
        'ratingEffect': -0.5,
        'changeChampionship': true,
        'affectRecord': true,
        'affectMorale': true,
        'feudStalenessEffect': 0.75,
        'category': 'dusty',
        'interference': false
    },
    {
        'name': 'Distraction',
        'description': 'A roster member\'s distraction causes a participant to lose.',
        'cost': 0,
        'winMultiplier': 0.5,
        'lossMultiplier': 0.4,
        'ratingEffect': -0.5,
        'changeChampionship': true,
        'affectRecord': true,
        'affectMorale': true,
        'feudStalenessEffect': 1.0,
        'category': 'dusty',
        'interference': true
    },
    {
        'name': 'Countout',
        'description': 'A participant wins by countout.',
        'cost': 0,
        'winMultiplier': 0.25,
        'lossMultiplier': 0.15,
        'ratingEffect': -0.5,
        'changeChampionship': false,
        'affectRecord': true,
        'affectMorale': true,
        'feudStalenessEffect': 0.75,
        'category': 'dusty',
        'interference': false
    },
    {
        'name': 'Double Pin',
        'description': 'The referee declares that both participants\' shoulders were on the mat during the pin.',
        'cost': 20,
        'winMultiplier': 0.5,
        'lossMultiplier': 0.0,
        'ratingEffect': -0.25,
        'changeChampionship': false,
        'affectRecord': false,
        'affectMorale': false,
        'feudStalenessEffect': 0.5,
        'category': 'other',
        'interference': false,
        'draw': true
    },
    {
        'name': 'Time-limit Draw',
        'description': 'Participants wrestle till the time-limit, leading to a draw.',
        'cost': 50,
        'winMultiplier': 0.5,
        'lossMultiplier': -0.9,
        'ratingEffect': -0.25,
        'changeChampionship': false,
        'affectRecord': false,
        'affectMorale': false,
        'feudStalenessEffect': 0.5,
        'category': 'other',
        'interference': false,
        'draw': true
    },
    {
        'name': 'Squash',
        'description': 'A participant dominates another in a quick and one-sided match.',
        'cost': 70,
        'winMultiplier': 2.0,
        'lossMultiplier': 2.0,
        'ratingEffect': -2,
        'changeChampionship': true,
        'affectRecord': true,
        'affectMorale': true,
        'feudStalenessEffect': 1.0,
        'category': 'other',
        'interference': false
    },
    {
        'name': 'Ring Collapse',
        'description': 'Participants perform a move from the top rope, causing the ring to collapse.',
        'cost': 100,
        'winMultiplier': 0.5,
        'lossMultiplier': -1.0,
        'ratingEffect': 0.25,
        'changeChampionship': false,
        'affectRecord': false,
        'affectMorale': false,
        'feudStalenessEffect': 0.5,
        'category': 'special',
        'interference': false,
        'requirements': ['main_event'],
        'draw': true
    },
    {
        'name': 'Switch Alliance',
        'description': 'A manager betrays their client, causing them to lose, and joins the winner.',
        'cost': 100,
        'winMultiplier': 0.5,
        'lossMultiplier': -1.0,
        'ratingEffect': 0.25,
        'changeChampionship': true,
        'affectRecord': true,
        'affectMorale': true,
        'feudStalenessEffect': 1,
        'category': 'special',
        'interference': false,
        'requirements': ['level_2_producer', 'loser_has_manager', 'winner_has_no_manager'],
        'consequences': ['manager_leaves_loser_and_joins_winner']
    },
    {
        'name': 'Throw In Towel',
        'description': 'A manager throws in the towel for their client, causing them to lose.',
        'cost': 125,
        'winMultiplier': 1.0,
        'lossMultiplier': -1.5,
        'ratingEffect': 0.25,
        'changeChampionship': true,
        'affectRecord': true,
        'affectMorale': true,
        'feudStalenessEffect': 1,
        'category': 'special',
        'interference': false,
        'requirements': ['level_2_producer', 'loser_has_manager']
    },
    {
        'name': 'Respectful End',
        'description': 'A heel refuses to cheat and loses valiantly, earning everyone\'s respect.',
        'cost': 125,
        'winMultiplier': 1.0,
        'lossMultiplier': -1.2,
        'ratingEffect': 0.5,
        'changeChampionship': true,
        'affectRecord': true,
        'affectMorale': true,
        'feudStalenessEffect': 1,
        'category': 'special',
        'interference': false,
        'requirements': ['level_2_producer', 'hot_feud', 'heel_loser'],
        'consequences': ['heel_turns_face']
    },
    {
        'name': 'By Any Means',
        'description': 'A face goes to extreme lengths in order to win.',
        'cost': 125,
        'winMultiplier': 1.5,
        'lossMultiplier': -0.5,
        'ratingEffect': 0.5,
        'changeChampionship': true,
        'affectRecord': true,
        'affectMorale': true,
        'feudStalenessEffect': 1,
        'category': 'special',
        'interference': false,
        'requirements': ['level_2_producer', 'hot_feud', 'face_winner'],
        'consequences': ['face_turns_heel']
    },
    {
        'name': 'Screwjob',
        'description': 'A participant is in a submission when the referee unexpectedly calls for the bell.',
        'cost': 150,
        'winMultiplier': 1.5,
        'lossMultiplier': -2.0,
        'ratingEffect': 0.25,
        'changeChampionship': true,
        'affectRecord': true,
        'affectMorale': true,
        'feudStalenessEffect': 1,
        'category': 'special',
        'interference': false,
        'requirements': ['level_3_producer', 'title_match'],
        'consequences': ['feud_boost']
    },
    {
        'name': 'Pass Out',
        'description': 'A face turns to the dark side to win but the heel refuses to give up and ends up passing out.',
        'cost': 150,
        'winMultiplier': 1.0,
        'lossMultiplier': -2.5,
        'ratingEffect': 1.0,
        'changeChampionship': true,
        'affectRecord': true,
        'affectMorale': true,
        'feudStalenessEffect': 1,
        'category': 'special',
        'interference': false,
        'requirements': ['level_3_producer', 'hot_feud', 'face_vs_heel', 'face_winner'],
        'consequences': ['heel_turns_face', 'face_turns_heel']
    },
];

export {matchFinishesData}